module.exports = __webpack_public_path__ + "img/order.db871a77.png";